///<reference path="../../employee/sections/employee.ImageGallery.section.ts"/>
module Meevo.Plugins.Teachers {
    'use strict';

    export class ImageGallerySection extends Meevo.Plugins.Employee.ImageGallerySection {

        get auditNounForSave(): Model.NounEnum {
            return Model.NounEnum.TeacherImageGalleries;
        }
    }
}